import { Icon } from '@iconify/react';
import { useState, useEffect } from 'react';
import bugFilled from '@iconify/icons-ant-design/dollar-circle-outlined';
import { alpha, experimentalStyled as styled } from '@material-ui/core/styles';
import { Card, Typography } from '@material-ui/core';
import { fShortenNumber } from '../../../utils/formatNumber';
import { baseUrl } from '../../../utils/constants';

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: 'none',
  textAlign: 'center',
  padding: theme.spacing(5, 0),
  color: theme.palette.error.darker,
  backgroundColor: theme.palette.error.lighter
}));

const IconWrapperStyle = styled('div')(({ theme }) => ({
  margin: 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: 'center',
  marginBottom: theme.spacing(3),
  color: theme.palette.error.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(theme.palette.error.dark, 0)} 0%, ${alpha(
    theme.palette.error.dark,
    0.24
  )} 100%)`
}));

// ----------------------------------------------------------------------

const TOTAL = 0;

export default function AppBugReports() {
  const [dashSum, setDashSum] = useState({
    totalActive: 0,
    newMembers: 0,
    paymentsThisMonth: 0.0,
    failedDebitOrders: 0.0
  });

  useEffect(() => {
    getDashBoardSummaries();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getDashBoardSummaries = () => {
    fetch(`${baseUrl}/api/client/getDashBoardSummaries`)
      .then((res) => res.json())
      .then(
        (result) => {
          setDashSum(result.result);
        },
        (error) => {}
      );
  };
  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={bugFilled} width={24} height={24} />
      </IconWrapperStyle>
      <Typography variant="h3">{fShortenNumber(dashSum.failedDebitOrders)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Processed Claims
      </Typography>
    </RootStyle>
  );
}
